<script>
import axios from 'axios';
import { mapState, mapGetters } from 'vuex';
import { allAboutDates } from '../mixins/allAboutDates.js';

export default {
  name: 'Login',
  data(){
    return{
      email:"",
      password:"",
      erreurs: [""],
    }
  },
  computed: {
    ...mapState({
      shortcut: state => state.auth.currentUser.name,
    }),
    ...mapGetters({
      displayAll: 'auth/displayAll',
    }),
  },
  mixins:[
    allAboutDates,
  ],
  methods: {
    async login(){
      this.erreurs = [""];
      var user = {
        email: this.email,
        password: this.password,
      };
      var payload = {}

      //Login de l'user
      await axios.post('users/login', user)
          .then(response => {
            payload.token = response.data.token;
            payload.user  = response.data.user;
            payload.perm  = response.data.perm;

            // Si ces deux valeurs existent et ne sont pas falsy
            if (payload.token && payload.user){
              this.$store.dispatch('auth/login', payload);
            }
          })
          .catch(e => {
            console.log(e);
            this.erreurs = [e.response.data.error];
          });

      //L'user est bon, je charge les infos de son agence
      await axios.get('agences/'+ payload.user.agenceId)
          .then(response => {
            payload.agence = response.data;
          })
          .catch(e => {
            console.log(e);
            this.erreurs = [e.response.data.error];
          });

      this.$store.dispatch('auth/set_agence', payload);

      //Routine à l'ouverture de l'application
      //-----Nombre de jours moyen par mois pour l'année en cours. S'il n'y encore rien d'inscrit pour cette année, j'ajoute ma valeur calculée.
      let anneeEnCours = new Date
      anneeEnCours = anneeEnCours.getUTCFullYear()
      let actualNbJours = payload.agence.estimationsAnnuelles.nbJours.find(e => e.annee == anneeEnCours)

      if (!actualNbJours || actualNbJours.val <= 0){
        let newVal = Math.round(this.joursOuvres(anneeEnCours, payload.agence.alsace)/12*100)/100
        // payload.agence.estimationsAnnuelles.nbJours.splice(payload.agence.estimationsAnnuelles.nbJours.findIndex(e => e.annee == anneeEnCours), 1)
        payload.agence.estimationsAnnuelles.nbJours.push({annee: anneeEnCours, val: newVal})
        axios.put('agences/' + payload.agence._id, payload.agence)
        .then(response => console.log(response))
        .catch(e => console.log(e))
      }

      //tant qu'il n'y a rien pour les salariés dans l'accueil, je les envoie directement sur la page de saisie des temps. Plus tard ça pourrait être sympa et plus logique d'avoir une même page d'accueil pour tout le monde (avec chacun ses widget et infos bien sûr)
      if (payload.perm.projetAnalyses && payload.perm.projetAnalyses.lecture) {
        this.$router.push('/accueil');
      } else {
          this.$router.push('/saisie');
      }
      
    },
  },
}
</script>


<template>
    <div id="component" class="component">
      <div class="login">
      <div class="login__border">
          <div class="login__border__items">
          <div class="login__border__items__title"><p>Connexion</p></div>
          <form @submit.prevent="login">
              <i class="logIcon material-icons md-18">perm_identity</i><input type="email" v-model="email" class="login__border__items__input" name="email" placeholder="adresse email" autofocus required/><br />
              <i class="logIcon material-icons md-18">lock_outline</i><input type="password" v-model="password" class="login__border__items__input" name="password" placeholder="mot de passe" required/><br />
              <!-- <a id="logMdpOubli" href=# title="demander un nouveau mot de passe">mot de passe oublié ?</a><br/> -->
              <input class="login__border__items__submit" type="submit" value="SE CONNECTER"/>
              <div class="login__border__items__error" v-for="erreur in erreurs" :key="erreur"> {{ erreur }} </div>
          </form>
          </div>
      </div>
        </div>
    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/main.scss';

.component{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  background: url('../assets/loginBackground.jpg') no-repeat center;
  background-size: cover;
  background-attachment: fixed;
}

.login:before{
  content: "";
  background: inherit;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  box-shadow: inset 0 0 2000px rgba(255, 255, 255, .35);
  filter: blur(4px);
  width: 100vw;
  height: 100vh;
}

.login{
    background: inherit;
    position: absolute; //Ajouté pour le blur de pseudo élément
    overflow: hidden;
    box-shadow: 0 1px 10px rgba(0,0,0, .15);
    padding: 30px;
    width: 600px;
    border-radius: 10px;

    &__border{
      position: relative;
      padding: 40px;
      border: white 1px solid;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: white;

      &__items{
        display: flex;
        flex-direction: column;
        text-align: center;

        &__title{
          font-family: 'Muli', sans-serif;
          font-size: x-large;
          font-weight: 300;
          margin-bottom: 20px;
        }

        & form{
          text-align: center;
        }

        & i{
          margin-right: -30px;
          vertical-align: text-bottom;
          font-size: medium;
          color: white;
        }

        &__input{
          border: none;
          border-bottom: white 0.5px solid;
          background: transparent;
          text-align: center;
          width: 190px;
          margin: 10px;
          height: 22px;
          font-family: 'Muli', sans-serif;
          font-weight: 300;
          padding-left: 30px;
          padding-right: 30px;
          color: white;
        }

        &__submit{
          margin-top: 45px;
          margin-bottom: 10px;
          border: 0.5px solid white;
          background: transparent;
          font-family: 'Muli', sans-serif;
          height: 30px;
          width: 250px;
          border-radius: 15px;
          font-size: small;
          color: white;

          &:hover{
            color: $main;
            background-color: white;
            cursor: pointer;
            font-weight: 600;
          }
        }

        &__error{
          color: $alert;
          margin-top: 10px;
          @include myFont;
          height: 20px;
        }
      }
    }
}

#logMdpOubli{
    color: white;
    text-decoration: none;
    font-family: 'Muli', sans-serif;
    font-size: x-small;
    position: relative;
    right : -68px;
    top : -12px;
}

</style>
